import { ajax } from './ajax'

//1、课中活动获取教学课程名称（无分页）
export const reqKzjxCourseList = () => ajax(`/jxcourse/jxCourse/getActivCourseList`)

//1、获取教学课程名称（无分页）
export const reqjxCourseList = () => ajax(`/jxcourse/jxCourse/NoPageList`)

//2、根据课程名称获取班级名称（无分页）
export const reqjxClassList = (paramets) => ajax(`/jxplan/jxPlan/getClassByCourseId`, paramets)

//3、删除上传的资源
export const reqDeleteFile = (paramets) => ajax(`/sys/common/deleteFile`, paramets, 'post')

// 4、测验-难易度和题型
export const reqTestSelect = (paramets) => ajax(`/sys/dictItem/getItemList`, paramets)

// 4、测验 - 试题列表
// export const reqDeleteFile = (paramets) => ajax(`/sys/common/deleteFile`, paramets, 'post')
// export const reqDeleteFile = (paramets) => ajax(`/sys/common/deleteFile`, paramets, 'post')

//4、上传图片
export const reqUploadFile = (paramets) => ajax(`/sys/common/upload`, paramets, 'post')

//5、添加试题
export const reqTestAdd = (paramets) => ajax(`/test/jxTest/add`, paramets, 'post')

//5、试题编辑
export const reqTestEdit = (paramets) => ajax(`/test/jxTest/edit`, paramets, 'put')

//5、试题分页查询
export const reqTestList = (paramets) => ajax(`/test/jxTest/gettest_list`, paramets)

//5、试题分页s删除
export const reqTestListDel = (paramets) => ajax(`/test/jxTest/deleteBatch`, paramets, 'delete')

//4、下载试题表格模板
export const reqDownExcel = (paramets) => ajax(`/sys/common/download/`, paramets, )



// WEBPACK FOOTER //
// ./src/api/global.js